/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Updater = {
    perform: function() {
        var visible = Main.plugins.vis();

        if (visible) {
            $.ajax({
                url: '/a/updater',
                type: 'GET'
            }).done(function(data) {
                if (data.alert !== null) {
                    var content;

                    if (data.alert.author != null) {
                        content = data.alert.content + '<br><br>Enviado por <b>'+data.alert.author+'</b> em <b>'+data.alert.date+'</b>';
                    } else {
                        content = data.alert.content + '<br><br>Enviado em <b>'+data.alert.date+'</b>';
                    }
                    Alertbox({
                        title: data.alert.title,
                        content: content,
                        type: 'misc'
                    });
                }

                setTimeout(function() {
                    Updater.perform();
                }, 20000);
            });
        } else {
            setTimeout(function() {
                Updater.perform();
            }, 3000);
        }
    },
    init: function() {
        Updater.perform();
    }
};
